<template>
  <div
    class="modal fade"
    id="telegram-notifications"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="notifications-sms-close"
          ></button>
          <div class="text-center">
            <h4 class="mb-8">{{ $t("notifications.type.telegram") }}</h4>
          </div>
          <div class="row border gap-y-4 p-4">
            <div class="col-12">
              <h5>
                {{ $t("notifications.tg.admins_transactions_log_group") }}
              </h5>
              <p class="text-muted">
                {{ $t("notifications.tg.admins_group_note") }}
              </p>
              <p class="text-muted">
                {{ $t("notifications.tg.admins_group_id_note") }}
              </p>
              <h5
                class="cursor-pointer"
                @click="copyToClip('@ssradius_transactions_bot')"
              >
                <i class="ti ti-copy"></i> @ssradius_transactions_bot
              </h5>
            </div>
            <div class="col-12">
              <label class="form-label">{{
                $t("notifications.tg.telegram_admins_log_group")
              }}</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                v-model="notifications.tg_admins_log_group_id"
              />
            </div>
            <div class="row mt-6">
              <div class="col-12 text-center">
                <button
                  class="btn btn-primary"
                  @click.prevent="store"
                  :disabled="!validated || loading"
                >
                  {{ $t("control.save") }}
                </button>
              </div>
            </div>
          </div>
          <div class="row border gap-y-4 p-4">
            <div class="col-12">
              <h5>
                {{ $t("notifications.tg.network_accounts_bot") }}
              </h5>
              <p class="text-muted">
                {{ $t("notifications.tg.netowrk_accounts_bot_note") }}
              </p>
              <p class="text-muted">
                {{ $t("notifications.tg.network_accounts_bot_note2") }}
              </p>
              <h5 class="cursor-pointer" @click="copyToClip('@botfather')">
                <i class="ti ti-copy"></i> @botfather
              </h5>
            </div>
            <div class="col-12">
              <label class="form-label">Bot Token</label>
              <input
                type="text"
                class="form-control"
                autocomplete="one-time-code"
                dir="ltr"
                placeholder="ex: 123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11"
                @input="validate()"
                v-model="notifications.tg_accounts_bot_token"
              />
            </div>
            <div class="col-12">
              <label
                class="form-check-label custom-option-content"
                for="opspeed"
              >
                <input
                  name="openprofilespeed"
                  class="form-check-input"
                  type="checkbox"
                  @input="validate"
                  v-model="notifications.tg_accounts_notifications_enaled"
                />
                {{ $t("notifications.tg.account_notifications_enabled") }}
              </label>
            </div>
            <div class="row mt-6">
              <div class="col-12 text-center">
                <div
                  class="text-danger text-sm"
                  v-if="errors.tg_accounts_bot_token"
                >
                  {{ errors.tg_accounts_bot_token }}
                </div>
                <button
                  class="btn btn-primary"
                  @click.prevent="store_bot"
                  :disabled="!validated_bot || loading"
                >
                  {{ $t("control.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { hasPrivilege } from "../../global_constants";

export default {
  name: "notificationsTelegram",
  data() {
    return {
      qr: null,
      loading: false,
      status: "",
      notifications: {
        tg_admins_log_group_id: null,
        tg_accounts_bot_token: null,
        tg_accounts_notifications_enaled: false,
      },
      instance: {
        instance: "",
      },
      instance_error: null,
      validated: true,
      validated_bot: false,
      errors: {
        expired: null,
        expiring: null,
        custom_expiration_length: null,
        custom_expiring_soon_length: null,
        custom_renew_length: null,
        custom_sham_renew_length: null,
        renew: null,
        tg_accounts_bot_token: null,
      },
      inside_page: true,
      showDeleteWa: false,
      text_direction:
        this.$i18n.locale == "ar" ? "direction:rtl" : "direction:ltr",
    };
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },

  async created() {
    this.fetchSettings();
  },
  watch: {
    $route(to, from) {
      this.inside_page = false;
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchSettings() {
      this.loading = true;
      const response = await axios.get("tg/notifications");
      if (response.status == 200) {
        var temp = response.data.data;
        temp.forEach((element) => {
          switch (element.key) {
            case "tg_admins_log_group_id":
              this.notifications.tg_admins_log_group_id = element.value;
              break;
            case "tg_accounts_notifications_enaled":
              this.notifications.tg_accounts_notifications_enaled =
                element.value == "1";
              break;
            case "tg_accounts_bot_token":
              this.notifications.tg_accounts_bot_token = element.value;
              break;
            default:
              break;
          }
        });
      }
      this.loading = false;
    },
    async store() {
      this.loading = true;
      const response = await axios.post("tg/notifications", this.notifications);
      if (response.status == 200) {
        this.$notify({
          text: this.$t(
            "notifications.tg.telegram_settings_updated_successfully"
          ),
          type: "success",
        });
      }
      this.loading = false;
    },
    async store_bot() {
      this.loading = true;
      const response = await axios.post("tg/accounts/bot", this.notifications);
      if (response.status == 210) {
        this.$notify({
          text: this.$t("notifications.tg.telegram_bot_already_used"),
          type: "error",
        });
        this.loading = false;
        this.validated_bot = false;
      } else if (response.status == 200) {
        this.$notify({
          text: this.$t(
            "notifications.tg.telegram_settings_updated_successfully"
          ),
          type: "success",
        });
      }
      this.loading = false;
    },
    copyToClip(text) {
      // Select the text field
      // Copy the text inside the text field
      navigator.clipboard.writeText(text);
      this.$notify({
        text: this.$t("control.copied_to_clipboard"),
        type: "info",
      });
    },
    validate() {
      this.validated = true;
      this.validated_bot = true;
      this.errors.tg_accounts_bot_token = null;
      if (
        this.notifications.tg_accounts_bot_token == null ||
        this.notifications.tg_accounts_bot_token == ""
      ) {
        this.validated_bot = false;
      }
      if (
        /^[0-9]{8,10}:[a-zA-Z0-9_-]{35}$/.test(
          this.notifications.tg_accounts_bot_token
        ) == false
      ) {
        this.validated_bot = false;
        this.errors.tg_accounts_bot_token = "invalid token";
      }
    },
  },
};
</script>
